import theme from "../../theme";
import type { DashboardStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<DashboardStyles, SxProps<Theme>> => {
  return {
    tabs: {
      display: "flex",
      width: "25%",
      justifyContent: "space-between",
    },

    modalRoot: {
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, 10%)",
      backgroundColor: "#FFFFFF",
      minHeight: "60%",
      width: "40%",
      padding: theme.spacing(5),
    },

    close: {
      position: "absolute",
      top: 0,
      right: 0,
    },
  };
};

export default getStyles;
